// extracted by mini-css-extract-plugin
export default {"header":"SectionHeader_header__P7Zge","line":"SectionHeader_line__iLLBa","title":"SectionHeader_title__ncedf"};